---
fr:
  marketplace:
    add_now: Ajouter maintenant
    add_tags: Ajouter des tags
    body: Texte principal
    card_info: Information de la carte
    confirmation: Êtes-vous sûr·e ?
    contact_info: Données de contact§
    filter: Filtre basé sur la catégorie
    heading: Place de marché
    image: Image
    image_to_large: La taille de l'image doit être inférieure à 5 MB !
    tags: Tags
    unexpected_error: Une erreur inattendue est survenue
